import template from './layout-photo.jade';

export default angular
    .module('cian.addForm.layoutPhoto', [])
    .directive('cianAfAboutObjectLayoutPhoto', () => ({
        scope: {},
        bindToController: {
            ad: '=',
            form: '=',
        },
        controller: [function () {
            this.ad.layoutPhoto = this.ad.layoutPhoto || null;
        }],
        controllerAs: 'layoutPhoto',
        template,
    }))
    .name;
